import auth from '@/modules/auth/routes'
import dashboard from '@/modules/dashboard/routes'
import pages from '@/modules/pages/routes'
import blog from '@/modules/blog/routes'
import press from '@/modules/press/routes'
import settings from '@/modules/settings/routes'
import media from '@/modules/media/routes'

export default [...auth, ...dashboard, ...pages, ...settings, ...blog, ...press, ...media]
